import { CommonEnums } from '../../common.enums';

export class Conn {

  /**
   * this is conn_Id, It should not be null.
   */
  conn_Id: number;

  /**
   * nm is name of the Repconn. 
   * size is 50
   */
  nm: string;

  /**
   * aliasNm is alias name of the Repconn. 
   * size is 50
   */
  aliasNm: string;

  /**
   * size is 100
   */
  host: string;

  /**
   * size is 10
   */
  port: string;

  /**
   * nativeFlag is used to know whether the Repconn is Native licensed or not
   * size is 1
   * Accepted values are 'Y' or 'N'
   */
  nativeFlag: string;

  /**
   * size is 250
   */
  connParamNm: string;

  /**
   * type is Integer
   */
  dbTyp_Id: number;

  /**
   * size is 100
   */
  connType: string;

  region:string;

  /**
   * size is 20
   */
  ver: string;

  /**
   * size is 500
   */
  description: string;

  /**
   * size is 20
   */
  valid_Cd: string;

  /**
   * type is date
   */
  updateDt: Date;

  /**
   * size is 40
   */
  updateBy: string;

  /**
   * size is 500
   */
  hdfshost: string;

  /**
   *  
   * size is 500
   */
  hdfsport: string;

  /**
   *  
   * size is 500
   */
  wrhloc: string;

  /**
   *  
   * size is 20
   */
  hadoop_Dist: string;

  /**
   *  
   * type is bigint
   */
  flagent_Id: number;

  /**
   *  
   * size is 
   */

  fileloc: string;

  /**
   *  
   * size is 500
   */
  ftpFlag: string;

  /**
   *  
   * size is 100
   */
  ftpHost: string;

  /**
   *  
   * size is 500
   */
  ftpPort: string;

  /**
   *  
   * size is 50
   */
  ftpUsr: string;

  /**
   *  
   * size is 250
   */
  ftpPasswd: string;

  /**
   *  
   * size is 10
   */
  fileProtocol: string;

  /**
   *  
   * size is 20
   */
  secAuth: string;

  /**
   *  
   * size is 100
   */
  hive_Principal: string;

  /**
   *  
   * size is 100
   */
  user_Principal: string;

  /**
   *  
   * size is 50
   */
  secKeyTab: string;

  /**
   *  
   * size is 5000
   */
  secToken: string;

  /**
   *  
   * size is 150
   */
  url: string;

  /**
   *  
   * size is 20
   */
  dbVersion: string;

  /**
   *  
   * size is 20
   */
  exe_Engine: string;

  /**
   *  
   * type is text 
   */
  hdfs_Temp_Loc: string;

  /**
   *  
   * size is 500
   */
  yarnRMHost: string;

  /**
   *  
   * size is 500
   */
  yarnRMPort: string;

  /**
   *  
   * size is 100
   */
  mrJobHistHost: string;

  /**
   *  
   * size is 10
   */
  mrJobHistPort: string;

  /**
   *  
   * size is 150
   */
  hdfsPrincipal: string;

  /**
   *  
   * size is 150
   */
  yarnPrincipal: string;

  /**
   *  
   * size is 150
   */
  mapRedPrincipal: string;

  /**
   *  
   * size is 4000
   */
  hdfs_Location: string;

  /**
   *  
   * size is 100
   */
  jobTracker_Host: string;

  /**
   *  
   * size is 10
   */
  jobTracker_Port: string;

  /**
   *  
   * size is 1
   */
  agentGrpInd: string;

  /**
   *  
   * size is 50
   */
  dbAliasNm: string;

  /**
   *  
   * size is 500
   */
  hbase_Master_Host: string;

  /**
   *  
   * size is 500
   */
  hbase_Master_Port: string;

  /**
   *  
   * size is 500
   */
  zookeeper_Quorum_Host: string;

  /**
   *  
   * size is 500
   */
  zookeeper_Client_Port: string;

  /**
   *  
   * size is 4000
   */
  hbase_Location: string;

  /**
   *  
   * size is 500
   */
  spark_WebUrl_Port: number;

  /**
   *  
   * size is 4000
   */
  zookeeper_Znode_Parent: string;

  /**
   *  
   * size is 500
   */
  consumerKey: string;

  /**
   *  
   * size is 500
   */
  consumerSecret: string;

  /**
   *  
   * size is 500
   */
  accessTokenSecret: string;

  accessToken: string;

  privateFlg: string;

  /**
   *  
   * size is 50
   */
  queueNm: string;

  /**
   *  
   * size is 100
   */
  kerb_Server: string;

  /**
   *  
   * size is 500
   */
  kdc_Host: string;

  /**
   *  
   * size is 150
   */
  default_Releam: string;

  /**
   *  
   * size is 1
   */
  archive_Dir_Flg: string;

  /**
   *  
   * size is 4000
   */
  archive_Dir_Loc: string;

  /**
   *  
   * size is 1
   */
  hiveServe2HACnf_Flg: string;

  /**
   *  
   * size is 1
   */
  dfsHAConfig_Flg: string;

  /**
   *  
   * size is 2000
   */
  dfsNameService: string;

  /**
   *  
   * size is 2000
   */
  nameNodeIDs: string;

  /**
   *  
   * size is 2000
   */
  rpcAddrNameNodeID1: string;

  /**
   *  
   * size is 2000
   */
  rpcAddrNameNodeID2: string;

  /**
   *  
   * size is 2000
   */
  zookeeperNameSpace: string;

  /**
   *  
   * size is 1
   */
  //TODO publicFlg: string;

  /**
   *  
   * type is bigint, it should not be null
   */
  owner_Id: number;

  /**
   *  
   * size is 2000
   */
  jmsProvider: string;

  /**
   *  
   * size is 2000
   */
  jmsProviderURL: string;

  /**
   *  
   * size is 2000
   */
  destinationType: string;

  /**
   *  
   * size is 2000
   */
  destinationNm: string;

  /**
   *  
   * type is text
   */
  connectionFactory: string;

  /**
   *  
   * size is 50
   */
  sparkMode: string;

  /**
  *  
  * type is text
  */
  sparkYarnJarLocation: string;

  /**
   *  
   * size is 4000
   */
  hadoop_Conf_Path: string;

  /**
   *  
   * type is text
   */
  amazonS3Host: string;

  /**
   *  
   * type is text
   */
  bucketNm: string;

  /**
   *  
   * type is text
   */
  tempLoc_Azs3: string;

  /**
   *  
   * type is text
   */
  amzon_s3_mount: string;

  /**
   *  
   * type is text 
   */
  clusterNm: string;

  /**
   *  
   * size is 20
   */
  hdfs_SecAuth: string;

  /**
   *  
   * size is 10
   */
  transportMode: string;

  /**
   *  
   * size is 100
   */
  httpPath: string;

  /**
   *  
   * size is 10
   */
  sftpAuthMode: string;

  /**
   *  
   * size is 100
   */
  pvtKeyFileNm: string;

  /**
   *  
   * size is 2000
   */
  bootstrapServers: string;

  /**
   *  
   * size is 2000
   */
  zookeeperConnect: string;

  /**
   *  
   * size is 2000
   */
  topic: string;

  /**
   *  
   * size is 500
   */
  kafka_Regex: string;

  /**
   *  
   * size is 1000
   */
  ssl_trustStore: string;

  /**
   *  
   * size is 1000
   */
  ssl_trustStorePassword: string;

  /**
   *  
   * size is 1000
   */
  ssl_keyStore: string;

  /**
   *  
   * size is 1000
   */
  ssl_keyStorePassword: string;

  /**
   *  
   * size is 1
   */
  cs_SSL_Flag: string;

  /**
   *  
   * size is 20
   */
  sparkVersion: string;

  /**
   *  
   * size is  100
   */
  spark_History_Host: string;

  /**
   *  
   * size is 10
   */
  spark_History_Port: string;

  /**
   *  
   * size is 1000
   */
  warehouse_Properties: string;

  /**
   *  
   * size is 50
   */
  instSqlNm: string;

  /**
   *  
   * size is 100
   */
  codePage: string;

  /**
   *  
   * type is boolean
   */
  client_Session: boolean;

  /**
   *  
   * size is 100
   */
  sch_PoolNm: string;

  /**
   *  
   * size is 1
   */
  spark_dsa: string;

  /**
   *  
   * size is 15
   */
  query_Priority: string;

  /**
   *  
   * size is 50
   */
  hdfs_Rpc_Protection: string;

  /**
   *  
   * size is 
   */
  owner_Nm: string;

  /**
   *  
   * size is 
   */
  createBy: string;

  /**
   *  
   * size is 
   */
  flagentNm: string;

  /**
   *  
   * size is 
   */
  tform_Valid_Cd: string;

  /**
   *  
   * size is 
   */
  status: string;

  /**
   *  
   * size is 
   */
  type: string;

  /**
   *  
   * size is 
   */
  size: string;

  /**
   *  
   * size is 
   */
  auto_Suspend: string;

  /**
   *  
   * size is 
   */
  auto_Resume: string;

  /**
   *  
   * size is 
   */
  created_On: string;

  /**
   *  
   * size is 
   */
  resumed_On: string;

  /**
   *  
   * size is 
   */
  owner: string;

  /**
   *  
   * size is 
   */
  comment: string;

  /**
   *  
   * type is integer 
   */
  batchSize: number;

  /**
   *  
   * type is integer 
   */
  timeOut: number;

  /**
   *  
   * size is 250
   */
  agency_Id: string;
  /**
   *  
   * size is 250
   */
  advertiser_Id: string;

  /**
   *  
   * size is 100
   */
  platform: string;

  /**
   *  
   * size is 1
   */
  yarnRMHAEnabled_Flg: string;

  /**
   *  
   * size is 100
   */
  yarnRMSchHost: string;

  /**
   *  
   * size is 500
   */
  yarnRMSchPort: string;

  /**
   *  
   * size is 100  
   */
  yarnRMIDs: string;

  /**
   *  
   * size is 100
   */
  yarnRM1Address: string;

  /**
   *  
   * size is 100  
   */
  yarnRM2Address: string;

  /**
   *  
   * size is 100
   */
  yarnRMWebappAddress: string;

  /**
   *  
   * size is 2000
   */
  mapReduceApplicationClasspath: string;

  /**
   *  
   * size is 250
   */
  mapReduceFrameworkPath: string;

  /**
   *  
   * size is 100
   */
  mapReduceFrameworkName: string;

  /**
   *  
   * size is 500
   */
  mapReduceJobHistoryHost: string;

  /**
   *  
   * size is 500
   */
  mapReduceJobHistoryPort: string;

  /**
   *  
   * size is 100
   */
  mapReduceJobHistoryIntermediateDir

  /**
   *  
   * size is 50
   */
  hadoopDistributionVersion: string;

  /**
   *  
   * size is 250
   */
  clouderaManagerUser: string;

  /**
   *  
   * size is 1000
   */
  clouderaManagerPassword: string;

  /**
   *  
   * size is 100
   */
  clouderaManagerHost: string;

  /**
   *  
   * size is 500
   */
  clouderaManagerPort: string;

  /**
   *  
   * size is 20
   */
  clouderaManagerApiVer: string;

  /**
   *  
   * size is 10
   */
  protocol: string;

  /**
   *  
   * size is 100
   */
  yarnTimelineServerHost: string;

  /**
   *  
   * size is 500
   */
  yarnTimelineServerPort: string;

  /**
   *  
   * size is 20
   */
  yarnTimelineServerVersion: string;

  /**
   *  
   * size is 2000
   */
  yarnApplicationClasspath: String;

  /**
   *  
   * size is 250
   */
  yarnAppMapreduceAMStagingDir: string;

  /**
   *  
   * size is 1
   */
  spark_dts: string;

  /**
   *  
   * size is 1
   */
  access_Token_Flg: string;

  /**
   *  
   * size is 1
   */
  proxy_Flg: string;

  /**
   *  
   * type is text
   */
  jdbcOptions: string;

  /**
    *  
    * size is 1
    */
  passwordFlag: string;

  /**
    *  
    * size is 1
    */
  tokenFlag: string;

  /**
    *  
    * size is 1
    */
  ssl_trustStorePasswordFlag: string;

  sparkUIPort: string;											// DDS-7302 Spark Local Mode integration <gkumar 15-04-2019>
  cpuCores: string;
  wsSecurityAuth: string;
  tenantName: string;
  defaultFlg: string;//DDS-8346

  forcibleSave: string; //readonly when other user open dependency of dp, user want forcible save //Bug-DDS-7330 <Ryella><03 JUN 2019>
  //Ansari 31-05-2019 DDS-7472 Connection to oracle cloud
  ssl_version: string;
  conndbtype: string;
  storagetype: string;
  ssl_keyStorePasswordFlag: string;//Ansari 26-06-2019 DDS-7472 Connection to oracle cloud

  //<DDS-7773><knalam><Jul 12, 2019>
  secretFlag: string;

  useConfXmlsFlag: string;

  authentication: string;

  ssl_mode: string;
  ssl_rootCertificate: string;
  ssl_cipherSuites: string;
  showQueryIdFlag: string;
  enableTransMngrFlag: string;
  additionalDfsConfig: string;
  acknowledgementMode: string;
  rowScanDepth: string;
  sasl_mechanism: string;
  jaas_confFilePath:string;

  constructor() {
    this.setDefaults();
  }
  setDefaults() {
    this.conn_Id = CommonEnums.defaults.LONG_VAL;
    this.nm = CommonEnums.defaults.STRING_EMPTY;
    this.aliasNm = CommonEnums.defaults.STRING_EMPTY;
    this.host = CommonEnums.defaults.STRING_EMPTY;
    this.port = CommonEnums.defaults.STRING_EMPTY;
    this.nativeFlag = CommonEnums.defaults.STRING_EMPTY;
    this.connParamNm = CommonEnums.defaults.STRING_EMPTY;
    this.dbTyp_Id = CommonEnums.defaults.LONG_VAL;
    this.connType = CommonEnums.defaults.STRING_EMPTY;
    this.ver = CommonEnums.defaults.DEFAULT_VERSION_CODE;
    this.description = CommonEnums.defaults.STRING_EMPTY;
    this.valid_Cd = CommonEnums.defaults.DEFAULT_VALID_CD_VAL;
    this.region = CommonEnums.defaults.STRING_EMPTY;
    this.updateDt = new Date(); //TODO
    this.updateBy = CommonEnums.defaults.STRING_EMPTY;
    this.hdfshost = CommonEnums.defaults.STRING_EMPTY;
    this.hdfsport = CommonEnums.defaults.STRING_EMPTY;
    this.wrhloc = CommonEnums.defaults.STRING_EMPTY;
    this.hadoop_Dist = CommonEnums.defaults.DEFAULT_HADOOP_DIST;
    this.flagent_Id = CommonEnums.defaults.LONG_VAL;
    this.fileloc = CommonEnums.defaults.STRING_EMPTY;
    this.ftpFlag = CommonEnums.defaults.STRING_VAL_NO;
    this.ftpHost = CommonEnums.defaults.STRING_EMPTY;
    this.ftpPort = CommonEnums.defaults.STRING_EMPTY;
    this.ftpUsr = CommonEnums.defaults.STRING_EMPTY;
    this.ftpPasswd = CommonEnums.defaults.STRING_EMPTY;
    this.fileProtocol = CommonEnums.defaults.DEFAULT_FTP_LITERAL;
    this.secAuth = CommonEnums.defaults.SIMPLE_CODE;
    this.hive_Principal = CommonEnums.defaults.STRING_EMPTY;
    this.user_Principal = CommonEnums.defaults.STRING_EMPTY;
    this.secKeyTab = CommonEnums.defaults.STRING_EMPTY;
    this.secToken = CommonEnums.defaults.STRING_EMPTY;
    this.url = CommonEnums.defaults.STRING_EMPTY;
    this.dbVersion = CommonEnums.defaults.STRING_EMPTY;
    this.exe_Engine = CommonEnums.defaults.EXE_ENGINE_MR;
    this.hdfs_Temp_Loc = CommonEnums.defaults.DEFAULT_HDFS_TEMP_LOC;
    this.yarnRMHost = CommonEnums.defaults.STRING_EMPTY;
    this.yarnRMPort = CommonEnums.defaults.STRING_EMPTY;
    this.mrJobHistHost = CommonEnums.defaults.STRING_EMPTY;
    this.mrJobHistPort = CommonEnums.defaults.STRING_EMPTY;
    this.hdfsPrincipal = CommonEnums.defaults.STRING_EMPTY;
    this.yarnPrincipal = CommonEnums.defaults.STRING_EMPTY;
    this.mapRedPrincipal = CommonEnums.defaults.STRING_EMPTY;
    this.hdfs_Location = CommonEnums.defaults.STRING_EMPTY;
    this.jobTracker_Host = CommonEnums.defaults.STRING_EMPTY;
    this.jobTracker_Port = CommonEnums.defaults.STRING_EMPTY;
    this.agentGrpInd = CommonEnums.defaults.STRING_VAL_NO;
    this.dbAliasNm = CommonEnums.defaults.STRING_EMPTY;
    this.hbase_Master_Host = CommonEnums.defaults.STRING_EMPTY;
    this.hbase_Master_Port = CommonEnums.defaults.STRING_EMPTY;
    this.zookeeper_Quorum_Host = CommonEnums.defaults.STRING_EMPTY;
    this.zookeeper_Client_Port = CommonEnums.defaults.STRING_EMPTY;
    this.hbase_Location = CommonEnums.defaults.STRING_EMPTY;
    this.spark_WebUrl_Port = CommonEnums.defaults.DEFAULT_SPARK_WEBURL_PORT;
    this.zookeeper_Znode_Parent = CommonEnums.defaults.DEFAULT_ZOOKEEPER_ZNODE_PARENT;
    this.consumerKey = CommonEnums.defaults.STRING_EMPTY;
    this.consumerSecret = CommonEnums.defaults.STRING_EMPTY;
    this.accessTokenSecret = CommonEnums.defaults.STRING_EMPTY;
    this.accessToken = CommonEnums.defaults.STRING_EMPTY;
    this.hdfs_SecAuth = CommonEnums.defaults.SIMPLE_CODE;
    this.privateFlg = CommonEnums.defaults.STRING_VAL_NO;
    this.queueNm = CommonEnums.defaults.STRING_EMPTY;
    this.kerb_Server = CommonEnums.defaults.STRING_EMPTY;
    this.kdc_Host = CommonEnums.defaults.STRING_EMPTY;
    this.default_Releam = CommonEnums.defaults.STRING_EMPTY;
    this.archive_Dir_Flg = CommonEnums.defaults.STRING_VAL_NO;
    this.archive_Dir_Loc = CommonEnums.defaults.STRING_EMPTY;
    this.hiveServe2HACnf_Flg = CommonEnums.defaults.STRING_VAL_NO;
    this.dfsHAConfig_Flg = CommonEnums.defaults.STRING_VAL_NO;
    this.dfsNameService = CommonEnums.defaults.STRING_EMPTY;
    this.nameNodeIDs = CommonEnums.defaults.STRING_EMPTY;
    this.rpcAddrNameNodeID1 = CommonEnums.defaults.STRING_EMPTY;
    this.rpcAddrNameNodeID2 = CommonEnums.defaults.STRING_EMPTY;
    this.zookeeperNameSpace = CommonEnums.defaults.STRING_EMPTY;
    //   this.publicFlg = CommonEnums.defaults.STRING_VAL_NO;
    this.owner_Id = CommonEnums.defaults.LONG_VAL;
    this.jmsProvider = CommonEnums.defaults.STRING_EMPTY;
    this.jmsProviderURL = CommonEnums.defaults.STRING_EMPTY;
    this.destinationType = CommonEnums.defaults.STRING_EMPTY;
    this.destinationNm = CommonEnums.defaults.STRING_EMPTY;
    this.connectionFactory = CommonEnums.defaults.STRING_EMPTY;
    this.sparkMode = CommonEnums.defaults.STRING_EMPTY;
    this.sparkYarnJarLocation = CommonEnums.defaults.STRING_EMPTY;
    this.hadoop_Conf_Path = CommonEnums.defaults.DEFAULT_HADOOP_CONF_PATH
    this.amazonS3Host = CommonEnums.defaults.STRING_EMPTY;
    this.bucketNm = CommonEnums.defaults.STRING_EMPTY;
    this.tempLoc_Azs3 = CommonEnums.defaults.STRING_EMPTY;
    this.amzon_s3_mount = CommonEnums.defaults.STRING_EMPTY;
    this.clusterNm = CommonEnums.defaults.SIMPLE_CODE;
    this.transportMode = CommonEnums.defaults.DEFAULT_BINARY_LITERAL;
    this.httpPath = CommonEnums.defaults.HTTP_PATH_CLISERVICE;
    this.sftpAuthMode = CommonEnums.defaults.SFTP_AUTH_MODE_PASSWORD;
    this.pvtKeyFileNm = CommonEnums.defaults.STRING_EMPTY;
    this.bootstrapServers = CommonEnums.defaults.STRING_EMPTY;
    this.zookeeperConnect = CommonEnums.defaults.STRING_EMPTY;
    this.topic = CommonEnums.defaults.STRING_EMPTY;
    this.kafka_Regex = CommonEnums.defaults.STRING_EMPTY;
    this.ssl_trustStore = CommonEnums.defaults.STRING_EMPTY;
    this.ssl_trustStorePassword = CommonEnums.defaults.STRING_EMPTY;
    this.ssl_keyStore = CommonEnums.defaults.STRING_EMPTY;
    this.ssl_keyStorePassword = CommonEnums.defaults.STRING_EMPTY;
    this.cs_SSL_Flag = CommonEnums.defaults.STRING_VAL_NO;
    this.sparkVersion = CommonEnums.defaults.STRING_EMPTY;
    this.spark_History_Host = CommonEnums.defaults.STRING_EMPTY;
    this.spark_History_Port = CommonEnums.defaults.STRING_EMPTY;
    this.warehouse_Properties = CommonEnums.defaults.STRING_EMPTY;
    this.instSqlNm = CommonEnums.defaults.STRING_EMPTY;
    this.codePage = CommonEnums.defaults.ASCII_CODE;
    this.client_Session = true;
    this.sch_PoolNm = 'default';
    this.spark_dsa = CommonEnums.defaults.STRING_VAL_NO;
    this.query_Priority = CommonEnums.defaults.QUERY_PRIORITY;
    this.hdfs_Rpc_Protection = 'None';
    this.owner_Nm = CommonEnums.defaults.STRING_EMPTY;
    this.createBy = CommonEnums.defaults.STRING_EMPTY;
    this.flagentNm = CommonEnums.defaults.STRING_EMPTY;
    this.tform_Valid_Cd = CommonEnums.defaults.DEFAULT_NUM_VAL;
    this.status = CommonEnums.defaults.STRING_EMPTY;
    this.type = CommonEnums.defaults.STRING_EMPTY;
    this.size = CommonEnums.defaults.STRING_EMPTY;
    this.auto_Suspend = CommonEnums.defaults.STRING_EMPTY;
    this.auto_Resume = CommonEnums.defaults.STRING_EMPTY;
    this.created_On = CommonEnums.defaults.STRING_EMPTY;
    this.resumed_On = CommonEnums.defaults.STRING_EMPTY;
    this.owner = CommonEnums.defaults.STRING_EMPTY;
    this.comment = CommonEnums.defaults.STRING_EMPTY;
    this.batchSize = CommonEnums.defaults.LONG_VAL;
    this.timeOut = CommonEnums.defaults.LONG_VAL;
    this.agency_Id = CommonEnums.defaults.STRING_EMPTY;
    this.advertiser_Id = CommonEnums.defaults.STRING_EMPTY;
    this.platform = CommonEnums.defaults.AWS_CODE;
    this.yarnRMHAEnabled_Flg = CommonEnums.defaults.STRING_VAL_NO;
    this.yarnRMSchHost = CommonEnums.defaults.STRING_EMPTY;
    this.yarnRMSchPort = CommonEnums.defaults.STRING_EMPTY;
    this.yarnRMIDs = CommonEnums.defaults.STRING_EMPTY;
    this.yarnRM1Address = CommonEnums.defaults.STRING_EMPTY;
    this.yarnRM2Address = CommonEnums.defaults.STRING_EMPTY;
    this.yarnRMWebappAddress = CommonEnums.defaults.STRING_EMPTY;
    this.mapReduceApplicationClasspath = CommonEnums.defaults.STRING_EMPTY;
    this.mapReduceFrameworkPath = CommonEnums.defaults.STRING_EMPTY;
    this.mapReduceFrameworkName = CommonEnums.defaults.STRING_EMPTY;
    this.mapReduceJobHistoryHost = CommonEnums.defaults.STRING_EMPTY;
    this.mapReduceJobHistoryPort = CommonEnums.defaults.STRING_EMPTY;
    this.mapReduceJobHistoryIntermediateDir = CommonEnums.defaults.STRING_EMPTY;
    this.hadoopDistributionVersion = CommonEnums.defaults.STRING_EMPTY;
    this.clouderaManagerUser = CommonEnums.defaults.STRING_EMPTY;
    this.clouderaManagerPassword = CommonEnums.defaults.STRING_EMPTY;
    this.clouderaManagerHost = CommonEnums.defaults.STRING_EMPTY;
    this.clouderaManagerPort = CommonEnums.defaults.DEFAULT_NUM_VAL;
    this.clouderaManagerApiVer = 'v17';
    this.protocol = CommonEnums.defaults.DEFAULT_PROTOCOL;
    this.yarnTimelineServerHost = CommonEnums.defaults.STRING_EMPTY;
    this.yarnTimelineServerPort = CommonEnums.defaults.STRING_EMPTY;
    this.yarnTimelineServerVersion = 'v1';
    this.yarnApplicationClasspath = CommonEnums.defaults.STRING_EMPTY;
    this.yarnAppMapreduceAMStagingDir = CommonEnums.defaults.STRING_EMPTY;
    this.spark_dts = CommonEnums.defaults.STRING_VAL_NO;
    this.access_Token_Flg = CommonEnums.defaults.STRING_VAL_NO;
    this.proxy_Flg = CommonEnums.defaults.STRING_VAL_NO;
    this.jdbcOptions = CommonEnums.defaults.STRING_EMPTY;
    this.passwordFlag = CommonEnums.defaults.STRING_VAL_NO;
    this.tokenFlag = CommonEnums.defaults.STRING_VAL_NO;
    this.ssl_trustStorePasswordFlag = CommonEnums.defaults.STRING_VAL_NO;
    this.sparkUIPort = CommonEnums.defaults.SPARK_UI_PORT;
    this.cpuCores = CommonEnums.defaults.SPARK_CPU_CORES;
    this.wsSecurityAuth = CommonEnums.defaults.STRING_VAL_NO;
    this.tenantName = CommonEnums.defaults.STRING_EMPTY;
    this.forcibleSave = CommonEnums.defaults.STRING_VAL_NO;
    this.ssl_version = CommonEnums.defaults.DEFAULT_SSL_VERSION_VAL;
    this.conndbtype = CommonEnums.defaults.STRING_EMPTY;
    this.storagetype = CommonEnums.defaults.STRING_EMPTY;
    this.ssl_keyStorePasswordFlag = CommonEnums.defaults.STRING_VAL_NO;
    this.secretFlag = CommonEnums.defaults.STRING_VAL_NO;
    this.defaultFlg = CommonEnums.defaults.STRING_VAL_NO;
    this.useConfXmlsFlag = CommonEnums.defaults.STRING_VAL_NO;
    this.authentication = CommonEnums.defaults.STRING_EMPTY;
    this.ssl_mode = CommonEnums.defaults.STRING_EMPTY;
    this.ssl_rootCertificate = CommonEnums.defaults.STRING_EMPTY;
    this.ssl_cipherSuites = CommonEnums.defaults.STRING_EMPTY;
    this.showQueryIdFlag = CommonEnums.defaults.STRING_EMPTY;
    this.enableTransMngrFlag = CommonEnums.defaults.STRING_VAL_NO;
    this.additionalDfsConfig = CommonEnums.defaults.STRING_EMPTY;
    this.acknowledgementMode = CommonEnums.defaults.STRING_EMPTY;
    this.rowScanDepth = CommonEnums.defaults.STRING_EMPTY;
    this.sasl_mechanism = CommonEnums.defaults.STRING_EMPTY;
    this.jaas_confFilePath = CommonEnums.defaults.STRING_EMPTY;
  }

  static parse(object: any): Conn {   // Constant method that is the same for every instance of a class.
    let conn: Conn = new Conn();
    conn.copyFrom(object as Conn);
    return conn;
  }

  copy(): Conn {
    let connTmp: Conn = new Conn();
    connTmp.conn_Id = this.conn_Id;
    connTmp.nm = this.nm;
    connTmp.aliasNm = this.aliasNm;
    connTmp.host = this.host;
    connTmp.port = this.port;
    connTmp.nativeFlag = this.nativeFlag;
    connTmp.connParamNm = this.connParamNm;
    connTmp.dbTyp_Id = this.dbTyp_Id;
    connTmp.connType = this.connType;
    connTmp.ver = this.ver;
    connTmp.description = this.description;
    connTmp.region = this.region;
    connTmp.valid_Cd = this.valid_Cd;
    connTmp.updateDt = this.updateDt;
    connTmp.updateBy = this.updateBy;
    connTmp.hdfshost = this.hdfshost;
    connTmp.hdfsport = this.hdfsport;
    connTmp.wrhloc = this.wrhloc;
    connTmp.hadoop_Dist = this.hadoop_Dist;
    connTmp.flagent_Id = this.flagent_Id;
    connTmp.fileloc = this.fileloc;
    connTmp.ftpFlag = this.ftpFlag;
    connTmp.ftpHost = this.ftpHost;
    connTmp.ftpPort = this.ftpPort;
    connTmp.ftpUsr = this.ftpUsr;
    connTmp.ftpPasswd = this.ftpPasswd;
    connTmp.fileProtocol = this.fileProtocol;
    connTmp.secAuth = this.secAuth;
    connTmp.hive_Principal = this.hive_Principal;
    connTmp.user_Principal = this.user_Principal;
    connTmp.secKeyTab = this.secKeyTab;
    connTmp.secToken = this.secToken;
    connTmp.url = this.url;
    connTmp.dbVersion = this.dbVersion;
    connTmp.exe_Engine = this.exe_Engine;
    connTmp.hdfs_Temp_Loc = this.hdfs_Temp_Loc;
    connTmp.yarnRMHost = this.yarnRMHost;
    connTmp.yarnRMPort = this.yarnRMPort;
    connTmp.mrJobHistHost = this.mrJobHistHost;
    connTmp.mrJobHistPort = this.mrJobHistPort;
    connTmp.hdfsPrincipal = this.hdfsPrincipal;
    connTmp.yarnPrincipal = this.yarnPrincipal;
    connTmp.mapRedPrincipal = this.mapRedPrincipal;
    connTmp.hdfs_Location = this.hdfs_Location;
    connTmp.jobTracker_Host = this.jobTracker_Host;
    connTmp.jobTracker_Port = this.jobTracker_Port;
    connTmp.agentGrpInd = this.agentGrpInd;
    connTmp.dbAliasNm = this.dbAliasNm;
    connTmp.hbase_Master_Host = this.hbase_Master_Host;
    connTmp.hbase_Master_Port = this.hbase_Master_Port;
    connTmp.zookeeper_Quorum_Host = this.zookeeper_Quorum_Host;
    connTmp.zookeeper_Client_Port = this.zookeeper_Client_Port;
    connTmp.hbase_Location = this.hbase_Location;
    connTmp.spark_WebUrl_Port = this.spark_WebUrl_Port;
    connTmp.zookeeper_Znode_Parent = this.zookeeper_Znode_Parent;
    connTmp.consumerKey = this.consumerKey;
    connTmp.consumerSecret = this.consumerSecret;
    connTmp.accessTokenSecret = this.accessTokenSecret;
    connTmp.accessToken = this.accessToken;
    connTmp.privateFlg = this.privateFlg;
    connTmp.queueNm = this.queueNm;
    connTmp.kerb_Server = this.kerb_Server;
    connTmp.kdc_Host = this.kdc_Host;
    connTmp.default_Releam = this.default_Releam;
    connTmp.archive_Dir_Flg = this.archive_Dir_Flg;
    connTmp.archive_Dir_Loc = this.archive_Dir_Loc;
    connTmp.hiveServe2HACnf_Flg = this.hiveServe2HACnf_Flg
    connTmp.dfsHAConfig_Flg = this.dfsHAConfig_Flg
    connTmp.dfsNameService = this.dfsNameService
    connTmp.nameNodeIDs = this.nameNodeIDs
    connTmp.rpcAddrNameNodeID1 = this.rpcAddrNameNodeID1
    connTmp.rpcAddrNameNodeID2 = this.rpcAddrNameNodeID2
    connTmp.zookeeperNameSpace = this.zookeeperNameSpace
    //   connTmp.publicFlg = this.publicFlg
    connTmp.owner_Id = this.owner_Id
    connTmp.jmsProvider = this.jmsProvider
    connTmp.jmsProviderURL = this.jmsProviderURL
    connTmp.destinationType = this.destinationType
    connTmp.destinationNm = this.destinationNm
    connTmp.connectionFactory = this.connectionFactory
    connTmp.sparkMode = this.sparkMode
    connTmp.sparkYarnJarLocation = this.sparkYarnJarLocation
    connTmp.hadoop_Conf_Path = this.hadoop_Conf_Path
    connTmp.amazonS3Host = this.amazonS3Host
    connTmp.bucketNm = this.bucketNm
    connTmp.tempLoc_Azs3 = this.tempLoc_Azs3
    connTmp.amzon_s3_mount = this.amzon_s3_mount
    connTmp.clusterNm = this.clusterNm
    connTmp.transportMode = this.transportMode
    connTmp.httpPath = this.httpPath
    connTmp.sftpAuthMode = this.sftpAuthMode
    connTmp.pvtKeyFileNm = this.pvtKeyFileNm
    connTmp.bootstrapServers = this.bootstrapServers
    connTmp.zookeeperConnect = this.zookeeperConnect
    connTmp.topic = this.topic
    connTmp.kafka_Regex = this.kafka_Regex
    connTmp.ssl_trustStore = this.ssl_trustStore
    connTmp.ssl_trustStorePassword = this.ssl_trustStorePassword
    connTmp.ssl_keyStore = this.ssl_keyStore
    connTmp.ssl_keyStorePassword = this.ssl_keyStorePassword
    connTmp.cs_SSL_Flag = this.cs_SSL_Flag
    connTmp.sparkVersion = this.sparkVersion
    connTmp.spark_History_Host = this.spark_History_Host
    connTmp.spark_History_Port = this.spark_History_Port
    connTmp.warehouse_Properties = this.warehouse_Properties
    connTmp.instSqlNm = this.instSqlNm
    connTmp.codePage = this.codePage
    connTmp.client_Session = this.client_Session
    connTmp.sch_PoolNm = this.sch_PoolNm
    connTmp.spark_dsa = this.spark_dsa
    connTmp.query_Priority = this.query_Priority
    connTmp.hdfs_Rpc_Protection = this.hdfs_Rpc_Protection
    connTmp.hdfs_SecAuth = this.hdfs_SecAuth
    connTmp.owner_Nm = this.owner_Nm
    connTmp.createBy = this.createBy
    connTmp.flagentNm = this.flagentNm
    connTmp.status = this.status
    connTmp.tform_Valid_Cd = this.tform_Valid_Cd;
    connTmp.type = this.type;
    connTmp.size = this.size;
    connTmp.auto_Suspend = this.auto_Suspend;
    connTmp.auto_Resume = this.auto_Resume;
    connTmp.created_On = this.created_On;
    connTmp.resumed_On = this.resumed_On;
    connTmp.owner = this.owner;
    connTmp.comment = this.comment;
    connTmp.batchSize = this.batchSize;
    connTmp.timeOut = this.timeOut;
    connTmp.agency_Id = this.agency_Id;
    connTmp.advertiser_Id = this.advertiser_Id;
    connTmp.platform = this.platform;
    connTmp.yarnRMHAEnabled_Flg = this.yarnRMHAEnabled_Flg;
    connTmp.yarnRMSchHost = this.yarnRMSchHost;
    connTmp.yarnRMSchPort = this.yarnRMSchPort;
    connTmp.yarnRMIDs = this.yarnRMIDs;
    connTmp.yarnRM1Address = this.yarnRM1Address;
    connTmp.yarnRM2Address = this.yarnRM2Address;
    connTmp.yarnRMWebappAddress = this.yarnRMWebappAddress;
    connTmp.mapReduceApplicationClasspath = this.mapReduceApplicationClasspath;
    connTmp.mapReduceFrameworkPath = this.mapReduceFrameworkPath;
    connTmp.mapReduceFrameworkName = this.mapReduceFrameworkName;
    connTmp.mapReduceJobHistoryHost = this.mapReduceJobHistoryHost;
    connTmp.mapReduceJobHistoryPort = this.mapReduceJobHistoryPort;
    connTmp.mapReduceJobHistoryIntermediateDir = this.mapReduceJobHistoryIntermediateDir;
    connTmp.hadoopDistributionVersion = this.hadoopDistributionVersion;
    connTmp.clouderaManagerUser = this.clouderaManagerUser;
    connTmp.clouderaManagerPassword = this.clouderaManagerPassword;
    connTmp.clouderaManagerHost = this.clouderaManagerHost;
    connTmp.clouderaManagerPort = this.clouderaManagerPort;
    connTmp.clouderaManagerApiVer = this.clouderaManagerApiVer;
    connTmp.protocol = this.protocol;
    connTmp.yarnTimelineServerHost = this.yarnTimelineServerHost
    connTmp.yarnTimelineServerPort = this.yarnTimelineServerPort;
    connTmp.yarnTimelineServerVersion = this.yarnTimelineServerVersion;
    connTmp.yarnApplicationClasspath = this.yarnApplicationClasspath;
    connTmp.yarnAppMapreduceAMStagingDir = this.yarnAppMapreduceAMStagingDir;
    connTmp.spark_dts = this.spark_dts;
    connTmp.access_Token_Flg = this.access_Token_Flg;
    connTmp.proxy_Flg = this.proxy_Flg;
    connTmp.jdbcOptions = this.jdbcOptions;
    connTmp.passwordFlag = this.passwordFlag;
    connTmp.tokenFlag = this.tokenFlag;
    connTmp.ssl_trustStorePasswordFlag = this.ssl_trustStorePasswordFlag;
    connTmp.sparkUIPort = this.sparkUIPort;
    connTmp.cpuCores = this.cpuCores;
    connTmp.wsSecurityAuth = this.wsSecurityAuth;
    connTmp.tenantName = this.tenantName;
    connTmp.forcibleSave = this.forcibleSave;
    connTmp.ssl_version = this.ssl_version;
    connTmp.conndbtype = this.conndbtype;
    connTmp.storagetype = this.storagetype;
    connTmp.ssl_keyStorePasswordFlag = this.ssl_keyStorePasswordFlag;
    connTmp.secretFlag = this.secretFlag;
    connTmp.defaultFlg = this.defaultFlg;
    connTmp.useConfXmlsFlag = this.useConfXmlsFlag;
    connTmp.authentication = this.authentication;
    connTmp.ssl_mode = this.ssl_mode;
    connTmp.ssl_rootCertificate = this.ssl_rootCertificate;
    connTmp.ssl_cipherSuites = this.ssl_cipherSuites;
    connTmp.showQueryIdFlag = this.showQueryIdFlag;
    connTmp.enableTransMngrFlag = this.enableTransMngrFlag;
    connTmp.additionalDfsConfig = this.additionalDfsConfig;
    connTmp.acknowledgementMode = this.acknowledgementMode;
    connTmp.rowScanDepth = this.rowScanDepth;
    connTmp.sasl_mechanism = this.sasl_mechanism;
    connTmp.jaas_confFilePath = this.jaas_confFilePath;
    return connTmp;
  }
  copyFrom(connTmp: Conn): void {
    this.conn_Id = connTmp.conn_Id;
    this.nm = connTmp.nm;
    this.aliasNm = connTmp.aliasNm;
    this.host = connTmp.host;
    this.port = connTmp.port;
    this.nativeFlag = connTmp.nativeFlag;
    this.connParamNm = connTmp.connParamNm;
    this.dbTyp_Id = connTmp.dbTyp_Id;
    this.connType = connTmp.connType;
    this.ver = connTmp.ver;
    this.description = connTmp.description;
    this.region = connTmp.region;
    this.valid_Cd = connTmp.valid_Cd;
    this.updateDt = connTmp.updateDt;
    this.updateBy = connTmp.updateBy;
    this.hdfshost = connTmp.hdfshost;
    this.hdfsport = connTmp.hdfsport;
    this.wrhloc = connTmp.wrhloc;
    this.hadoop_Dist = connTmp.hadoop_Dist;
    this.flagent_Id = connTmp.flagent_Id;
    this.fileloc = connTmp.fileloc;
    this.ftpFlag = connTmp.ftpFlag;
    this.ftpHost = connTmp.ftpHost;
    this.ftpPort = connTmp.ftpPort;
    this.ftpUsr = connTmp.ftpUsr;
    this.ftpPasswd = connTmp.ftpPasswd;
    this.fileProtocol = connTmp.fileProtocol;
    this.secAuth = connTmp.secAuth;
    this.hive_Principal = connTmp.hive_Principal;
    this.user_Principal = connTmp.user_Principal;
    this.secKeyTab = connTmp.secKeyTab;
    this.secToken = connTmp.secToken;
    this.url = connTmp.url;
    this.dbVersion = connTmp.dbVersion;
    this.exe_Engine = connTmp.exe_Engine;
    this.hdfs_Temp_Loc = connTmp.hdfs_Temp_Loc;
    this.yarnRMHost = connTmp.yarnRMHost;
    this.yarnRMPort = connTmp.yarnRMPort;
    this.mrJobHistHost = connTmp.mrJobHistHost;
    this.mrJobHistPort = connTmp.mrJobHistPort;
    this.hdfsPrincipal = connTmp.hdfsPrincipal;
    this.yarnPrincipal = connTmp.yarnPrincipal;
    this.mapRedPrincipal = connTmp.mapRedPrincipal;
    this.hdfs_Location = connTmp.hdfs_Location;
    this.jobTracker_Host = connTmp.jobTracker_Host;
    this.jobTracker_Port = connTmp.jobTracker_Port;
    this.agentGrpInd = connTmp.agentGrpInd;
    this.dbAliasNm = connTmp.dbAliasNm;
    this.hbase_Master_Host = connTmp.hbase_Master_Host;
    this.hbase_Master_Port = connTmp.hbase_Master_Port;
    this.zookeeper_Quorum_Host = connTmp.zookeeper_Quorum_Host;
    this.zookeeper_Client_Port = connTmp.zookeeper_Client_Port;
    this.hbase_Location = connTmp.hbase_Location;
    this.spark_WebUrl_Port = connTmp.spark_WebUrl_Port;
    this.zookeeper_Znode_Parent = connTmp.zookeeper_Znode_Parent;
    this.consumerKey = connTmp.consumerKey;
    this.consumerSecret = connTmp.consumerSecret;
    this.accessTokenSecret = connTmp.accessTokenSecret;
    this.accessToken = connTmp.accessToken;
    this.privateFlg = connTmp.privateFlg;
    this.queueNm = connTmp.queueNm;
    this.kerb_Server = connTmp.kerb_Server;
    this.kdc_Host = connTmp.kdc_Host;
    this.default_Releam = connTmp.default_Releam;
    this.archive_Dir_Flg = connTmp.archive_Dir_Flg;
    this.archive_Dir_Loc = connTmp.archive_Dir_Loc;
    this.hiveServe2HACnf_Flg = connTmp.hiveServe2HACnf_Flg
    this.dfsHAConfig_Flg = connTmp.dfsHAConfig_Flg
    this.dfsNameService = connTmp.dfsNameService
    this.nameNodeIDs = connTmp.nameNodeIDs
    this.rpcAddrNameNodeID1 = connTmp.rpcAddrNameNodeID1
    this.rpcAddrNameNodeID2 = connTmp.rpcAddrNameNodeID2
    this.zookeeperNameSpace = connTmp.zookeeperNameSpace
    this.hdfs_SecAuth = connTmp.hdfs_SecAuth
    //   this.publicFlg = connTmp.publicFlg
    this.owner_Id = connTmp.owner_Id
    this.jmsProvider = connTmp.jmsProvider
    this.jmsProviderURL = connTmp.jmsProviderURL
    this.destinationType = connTmp.destinationType
    this.destinationNm = connTmp.destinationNm
    this.connectionFactory = connTmp.connectionFactory
    this.sparkMode = connTmp.sparkMode
    this.sparkYarnJarLocation = connTmp.sparkYarnJarLocation
    this.hadoop_Conf_Path = connTmp.hadoop_Conf_Path
    this.amazonS3Host = connTmp.amazonS3Host
    this.bucketNm = connTmp.bucketNm
    this.tempLoc_Azs3 = connTmp.tempLoc_Azs3
    this.amzon_s3_mount = connTmp.amzon_s3_mount
    this.clusterNm = connTmp.clusterNm
    this.transportMode = connTmp.transportMode
    this.httpPath = connTmp.httpPath
    this.sftpAuthMode = connTmp.sftpAuthMode
    this.pvtKeyFileNm = connTmp.pvtKeyFileNm
    this.bootstrapServers = connTmp.bootstrapServers
    this.zookeeperConnect = connTmp.zookeeperConnect
    this.topic = connTmp.topic
    this.kafka_Regex = connTmp.kafka_Regex
    this.ssl_trustStore = connTmp.ssl_trustStore
    this.ssl_trustStorePassword = connTmp.ssl_trustStorePassword
    this.ssl_keyStore = connTmp.ssl_keyStore
    this.ssl_keyStorePassword = connTmp.ssl_keyStorePassword
    this.cs_SSL_Flag = connTmp.cs_SSL_Flag
    this.sparkVersion = connTmp.sparkVersion
    this.spark_History_Host = connTmp.spark_History_Host
    this.spark_History_Port = connTmp.spark_History_Port
    this.warehouse_Properties = connTmp.warehouse_Properties
    this.instSqlNm = connTmp.instSqlNm
    this.codePage = connTmp.codePage
    this.client_Session = connTmp.client_Session
    this.sch_PoolNm = connTmp.sch_PoolNm
    this.spark_dsa = connTmp.spark_dsa
    this.query_Priority = connTmp.query_Priority
    this.hdfs_Rpc_Protection = connTmp.hdfs_Rpc_Protection
    this.owner_Nm = connTmp.owner_Nm
    this.createBy = connTmp.createBy
    this.flagentNm = connTmp.flagentNm
    this.status = connTmp.status
    this.tform_Valid_Cd = connTmp.tform_Valid_Cd;
    this.type = connTmp.type;
    this.size = connTmp.size;
    this.auto_Suspend = connTmp.auto_Suspend;
    this.auto_Resume = connTmp.auto_Resume;
    this.created_On = connTmp.created_On;
    this.resumed_On = connTmp.resumed_On;
    this.owner = connTmp.owner;
    this.comment = connTmp.comment;
    this.batchSize = connTmp.batchSize;
    this.timeOut = connTmp.timeOut;
    this.agency_Id = connTmp.agency_Id;
    this.advertiser_Id = connTmp.advertiser_Id;
    this.platform = connTmp.platform;
    this.yarnRMHAEnabled_Flg = connTmp.yarnRMHAEnabled_Flg;
    this.yarnRMSchHost = connTmp.yarnRMSchHost;
    this.yarnRMSchPort = connTmp.yarnRMSchPort;
    this.yarnRMIDs = connTmp.yarnRMIDs;
    this.yarnRM1Address = connTmp.yarnRM1Address;
    this.yarnRM2Address = connTmp.yarnRM2Address;
    this.yarnRMWebappAddress = connTmp.yarnRMWebappAddress;
    this.mapReduceApplicationClasspath = connTmp.mapReduceApplicationClasspath;
    this.mapReduceFrameworkPath = connTmp.mapReduceFrameworkPath;
    this.mapReduceFrameworkName = connTmp.mapReduceFrameworkName;
    this.mapReduceJobHistoryHost = connTmp.mapReduceJobHistoryHost;
    this.mapReduceJobHistoryPort = connTmp.mapReduceJobHistoryPort;
    this.mapReduceJobHistoryIntermediateDir = connTmp.mapReduceJobHistoryIntermediateDir;
    this.hadoopDistributionVersion = connTmp.hadoopDistributionVersion;
    this.clouderaManagerUser = connTmp.clouderaManagerUser;
    this.clouderaManagerPassword = connTmp.clouderaManagerPassword;
    this.clouderaManagerHost = connTmp.clouderaManagerHost;
    this.clouderaManagerPort = connTmp.clouderaManagerPort;
    this.clouderaManagerApiVer = connTmp.clouderaManagerApiVer;
    this.protocol = connTmp.protocol;
    this.yarnTimelineServerHost = connTmp.yarnTimelineServerHost
    this.yarnTimelineServerPort = connTmp.yarnTimelineServerPort;
    this.yarnTimelineServerVersion = connTmp.yarnTimelineServerVersion;
    this.yarnApplicationClasspath = connTmp.yarnApplicationClasspath;
    this.yarnAppMapreduceAMStagingDir = connTmp.yarnAppMapreduceAMStagingDir;
    this.spark_dts = connTmp.spark_dts;
    this.access_Token_Flg = connTmp.access_Token_Flg;
    this.proxy_Flg = connTmp.proxy_Flg;
    this.jdbcOptions = connTmp.jdbcOptions;
    this.passwordFlag = connTmp.passwordFlag;
    this.tokenFlag = connTmp.tokenFlag;
    this.ssl_trustStorePasswordFlag = connTmp.ssl_trustStorePasswordFlag;
    this.sparkUIPort = connTmp.sparkUIPort;
    this.cpuCores = connTmp.cpuCores;
    this.wsSecurityAuth = connTmp.wsSecurityAuth;
    this.tenantName = connTmp.tenantName;
    this.forcibleSave = connTmp.forcibleSave;
    this.ssl_version = connTmp.ssl_version;
    this.conndbtype = connTmp.conndbtype;
    this.storagetype = connTmp.storagetype;
    this.ssl_keyStorePasswordFlag = connTmp.ssl_keyStorePasswordFlag;
    this.secretFlag = connTmp.secretFlag;
    this.defaultFlg = connTmp.defaultFlg;
    this.useConfXmlsFlag = connTmp.useConfXmlsFlag;
    this.authentication = connTmp.authentication;
    this.ssl_mode = connTmp.ssl_mode;
    this.ssl_rootCertificate = connTmp.ssl_rootCertificate;
    this.ssl_cipherSuites = connTmp.ssl_cipherSuites;
    this.showQueryIdFlag = connTmp.showQueryIdFlag;
    this.enableTransMngrFlag = connTmp.enableTransMngrFlag;
    this.additionalDfsConfig = connTmp.additionalDfsConfig;
    this.acknowledgementMode = connTmp.acknowledgementMode;
    this.rowScanDepth = connTmp.rowScanDepth;
    this.sasl_mechanism = connTmp.sasl_mechanism;
    this.jaas_confFilePath = connTmp.jaas_confFilePath;
  }

  compare(connTmp: Conn): string {
    let connString: string = this.toString(false);
    let connTmpString: string = connTmp.toString(false);

    if (connString != connTmpString) {
      return connString + ', ' + connTmpString;
    }

    return '';
  }

  toString(isNotCompare: boolean = true): string {
    let str: string = "Conn [conn_Id=" + this.conn_Id + ", nm=" + this.nm +
      ", aliasNm=" + this.aliasNm + ", host=" + this.host + ", hdfs_SecAuth =" + this.hdfs_SecAuth +
      ", port=" + this.port + ", nativeFlag=" + this.nativeFlag + ", connParamNm=" + this.connParamNm + ", dbTyp_Id=" + this.dbTyp_Id +
      ", connType=" + this.connType + ", ver=" + this.ver + ",description=" + this.description + 
      ", valid_Cd=" + this.valid_Cd + ", updateDt" + this.updateDt + ", updateBy=" + this.updateBy +
      ", hdfshost=" + this.hdfshost + ", hdfsport=" + this.hdfsport +
      ", wrhloc=" + this.wrhloc + ", hadoop_Dist=" + this.hadoop_Dist + ", flagent_Id=" + this.flagent_Id + ", fileloc=" + this.fileloc +
      ", ftpFlag=" + this.ftpFlag + ", ftpHost=" + this.ftpHost + ",ftpPort=" + this.ftpPort +
      ", ftpUsr=" + this.ftpUsr + ", ftpPasswd=" + this.ftpPasswd + ", fileProtocol=" + this.fileProtocol +
      ", secAuth=" + this.secAuth + ", hive_Principal=" + this.hive_Principal +
      ", user_Principal=" + this.user_Principal + ", secKeyTab=" + this.secKeyTab + ", secToken=" + this.secToken + ", url=" + this.url +
      ", dbVersion=" + this.dbVersion + ", exe_Engine=" + this.exe_Engine + ",hdfs_Temp_Loc=" + this.hdfs_Temp_Loc +
      ", yarnRMHost=" + this.yarnRMHost + ", yarnRMPort=" + this.yarnRMPort + ", mrJobHistHost=" + this.mrJobHistHost +
      ", mrJobHistPort=" + this.mrJobHistPort + ", hdfsPrincipal=" + this.hdfsPrincipal +
      ", yarnPrincipal=" + this.yarnPrincipal + ", mapRedPrincipal=" + this.mapRedPrincipal + ", hdfs_Location=" + this.hdfs_Location + ", jobTracker_Host=" + this.jobTracker_Host +
      ", jobTracker_Port=" + this.jobTracker_Port + ", agentGrpInd=" + this.agentGrpInd +
      ", dbAliasNm=" + this.dbAliasNm + ", hbase_Master_Host=" + this.hbase_Master_Host +
      ", hbase_Master_Port=" + this.hbase_Master_Port + ", zookeeper_Quorum_Host=" + this.zookeeper_Quorum_Host +
      ", zookeeper_Client_Port=" + this.zookeeper_Client_Port + ", hbase_Location=" + this.hbase_Location +
      ", spark_WebUrl_Port=" + this.spark_WebUrl_Port + ", zookeeper_Znode_Parent=" + this.zookeeper_Znode_Parent +
      ", consumerKey=" + this.consumerKey + ", consumerSecret=" + this.consumerSecret +
      ", accessTokenSecret=" + this.accessTokenSecret + ", accessToken=" + this.accessToken + ", queueNm=" + this.queueNm +
      ", kerb_Server=" + this.kerb_Server + ", kdc_Host=" + this.kdc_Host +
      ", default_Releam=" + this.default_Releam + ", archive_Dir_Flg=" + this.archive_Dir_Flg +
      ", archive_Dir_Loc=" + this.archive_Dir_Loc + ", hiveServe2HACnf_Flg=" + this.hiveServe2HACnf_Flg +
      ", dfsHAConfig_Flg=" + this.dfsHAConfig_Flg + ", dfsNameService=" + this.dfsNameService +
      ", nameNodeIDs=" + this.nameNodeIDs + ", rpcAddrNameNodeID1=" + this.rpcAddrNameNodeID1 +
      ", rpcAddrNameNodeID2=" + this.rpcAddrNameNodeID2 + ", zookeeperNameSpace=" + this.zookeeperNameSpace +
      ", owner_Id=" + this.owner_Id +
      ", jmsProvider=" + this.jmsProvider + ", jmsProviderURL=" + this.jmsProviderURL +
      ", destinationType=" + this.destinationType + ", destinationNm=" + this.destinationNm +
      ", connectionFactory=" + this.connectionFactory + ", sparkMode=" + this.sparkMode +
      ", sparkYarnJarLocation=" + this.sparkYarnJarLocation + ", hadoop_Conf_Path=" + this.hadoop_Conf_Path +
      ", amazonS3Host=" + this.amazonS3Host + ", bucketNm=" + this.bucketNm +
      ", tempLoc_Azs3=" + this.tempLoc_Azs3 + ", amzon_s3_mount=" + this.amzon_s3_mount +
      ", clusterNm=" + this.clusterNm + ", transportMode=" + this.transportMode +
      ", httpPath=" + this.httpPath + ", sftpAuthMode=" + this.sftpAuthMode +
      ", pvtKeyFileNm=" + this.pvtKeyFileNm + ", bootstrapServers=" + this.bootstrapServers +
      ", zookeeperConnect=" + this.zookeeperConnect + ", topic=" + this.topic +
      ", kafka_Regex=" + this.kafka_Regex + ", ssl_trustStore=" + this.ssl_trustStore +
      ", ssl_trustStorePassword=" + this.ssl_trustStorePassword + ", ssl_keyStore=" + this.ssl_keyStore +
      ", ssl_keyStorePassword=" + this.ssl_keyStorePassword + ", cs_SSL_Flag=" + this.cs_SSL_Flag +
      ", sparkVersion=" + this.sparkVersion + ", spark_History_Host=" + this.spark_History_Host +
      ", spark_History_Port=" + this.spark_History_Port + ", warehouse_Properties=" + this.warehouse_Properties +
      ", instSqlNm=" + this.instSqlNm + ", codePage=" + this.codePage +
      ", client_Session=" + this.client_Session + ", sch_PoolNm=" + this.sch_PoolNm +
      ", spark_dsa=" + this.spark_dsa + ", query_Priority=" + this.query_Priority +
      ", hdfs_Rpc_Protection=" + this.hdfs_Rpc_Protection +
      ", flagentNm=" + this.flagentNm +
      ", status=" + this.status + ", tform_Valid_Cd=" + this.tform_Valid_Cd +
      ", type=" + this.type + ", size=" + this.size +
      ", auto_Suspend=" + this.auto_Suspend + ", auto_Resume=" + this.auto_Resume +
      ", created_On=" + this.created_On + ", resumed_On=" + this.resumed_On +
      ", owner=" + this.owner + ", comment=" + this.comment +
      ", batchSize=" + this.batchSize + ", timeOut=" + this.timeOut +
      ", agency_Id=" + this.agency_Id + ", advertiser_Id=" + this.advertiser_Id +
      ", platform=" + this.platform + ", yarnRMHAEnabled_Flg=" + this.yarnRMHAEnabled_Flg +
      ", yarnRMSchHost=" + this.yarnRMSchHost + ", yarnRMIDs=" + this.yarnRMIDs +
      ", yarnRMSchPort=" + this.yarnRMSchPort + ", yarnRM1Address=" + this.yarnRM1Address +
      ", yarnRM2Address=" + this.yarnRM2Address +
      ", mapReduceApplicationClasspath=" + this.mapReduceApplicationClasspath + ", yarnRMWebappAddress=" + this.yarnRMWebappAddress +
      ", mapReduceFrameworkPath=" + this.mapReduceFrameworkPath + ", mapReduceFrameworkName=" + this.mapReduceFrameworkName +
      ", mapReduceJobHistoryHost=" + this.mapReduceJobHistoryHost + ", mapReduceJobHistoryPort=" + this.mapReduceJobHistoryPort +
      ", mapReduceJobHistoryIntermediateDir=" + this.mapReduceJobHistoryIntermediateDir + ", hadoopDistributionVersion=" + this.hadoopDistributionVersion +
      ", clouderaManagerUser=" + this.clouderaManagerUser + ", clouderaManagerPassword=" + this.clouderaManagerPassword +
      ", clouderaManagerHost=" + this.clouderaManagerHost + ", clouderaManagerPort=" + this.clouderaManagerPort +
      ", clouderaManagerApiVer=" + this.clouderaManagerApiVer + ", protocol=" + this.protocol +
      ", yarnTimelineServerHost=" + this.yarnTimelineServerHost + ", yarnTimelineServerPort=" + this.yarnTimelineServerPort +
      ", yarnTimelineServerVersion=" + this.yarnTimelineServerVersion + ", yarnApplicationClasspath=" + this.yarnApplicationClasspath +
      ", yarnAppMapreduceAMStagingDir=" + this.yarnAppMapreduceAMStagingDir + ", spark_dts=" + this.spark_dts +
      ", access_Token_Flg=" + this.access_Token_Flg + ", proxy_Flg=" + this.proxy_Flg +
      ", jdbcOptions=" + this.jdbcOptions + ", passwordFlag=" + this.passwordFlag +
      ", tokenFlag=" + this.tokenFlag + ", ssl_trustStorePasswordFlag=" + this.ssl_trustStorePasswordFlag +
      ", sparkUIPort=" + this.sparkUIPort + ", cpuCores=" + this.cpuCores +
      ", wsSecurityAuth=" + this.wsSecurityAuth + ", tenantName=" + this.tenantName +
      ", forcibleSave=" + this.forcibleSave + ", ssl_version=" + this.ssl_version +
      ", conndbtype=" + this.conndbtype + ", storagetype=" + this.storagetype +
      ", ssl_keyStorePasswordFlag=" + this.ssl_keyStorePasswordFlag + ", secretFlag=" + this.secretFlag + ", privateFlg=" + this.privateFlg + ", defaultFlg=" + this.defaultFlg +
      ", useConfXmlsFlag=" + this.useConfXmlsFlag + ", authentication=" + this.authentication +
      ", ssl_mode=" + this.ssl_mode + ", ssl_rootCertificate=" + this.ssl_rootCertificate +
      ",ssl_cipherSuites=" + this.ssl_cipherSuites + ", showQueryIdFlag=" + this.showQueryIdFlag + ", enableTransMngrFlag=" + this.enableTransMngrFlag + 
      ", additionalDfsConfig=" + this.additionalDfsConfig + ", acknowledgementMode=" + this.acknowledgementMode + ", rowScanDepth=" + this.rowScanDepth+
      ", sasl_mechanism=" + this.sasl_mechanism + ", jaas_confFilePath=" + this.jaas_confFilePath + ", region=" + this.region;
 

    if (isNotCompare) {
      str += ", owner_Nm=" + this.owner_Nm + ", createBy=" + this.createBy;
    }

    str += "]";

    return str;
  }
}